// extracted by mini-css-extract-plugin
module.exports = {"varIndigo400":"var(--tkww-union-color-indigo-400, var(--tkww-union-color-additional-01extra-100, #E6F2FC))","tab":"tab--bd686","no-tab":"no-tab--e08d1","noTab":"no-tab--e08d1"};